require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-i-ufvo.json") })
        }
      }, "path---photos-professional-i-ufvo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-i-ufvo!./.cache/json/photos-professional-i-ufvo.json
// module id = 777
// module chunks = 231608221292675